/**
 * Storefront CATEGORY banner -- the size the store editor RECOMMENDS
 * (StoreCategories/CategoryCard.vue).
 *
 * GH-3633 (Jake, 2026-10-22): the category page header now renders EXACTLY
 * like the home banner, through the shared StorefrontBanner component
 * (components/Storefront/StorefrontBanner.vue): a full-bleed band, image at
 * the full viewport width, height capped at HERO_BANNER_MAX_HEIGHT
 * (utils/heroCarouselLayout.js), object-fit: contain so it is never cropped.
 * This module therefore holds only the ADVICE; the render geometry has one
 * source of truth (the shared component + constant).
 *
 * It replaces the 2026-10-06 rule (PR #4065) that kept the banner inside the
 * width-capped content column at max 210px tall and centered. That fixed the
 * crop but left the category header looking like a small inset strip next to
 * the home banner.
 *
 * WHY 6:1. A category banner introduces a page whose job is its product grid;
 * a tall banner pushes the products below the fold, worst on a phone. Slim
 * "collection header" banners are commonly 1920 x 300-500 (about 6.4:1 to
 * 3.8:1), and Jake asked for 6:1 to 8:1. 6:1 is the TALLER end of that range
 * on purpose: at 390px wide an 8:1 banner is ~49px tall, too short for text
 * baked into it to stay legible; 6:1 gives 65px.
 *
 * DERIVATION of the recommended size: the banner spans the viewport, so the
 * target is a 1440px desktop at 2x (retina) = 2880 wide, at 6:1 = 480 tall.
 * Wider monitors upscale gently; the 620px height cap is never reached at 6:1
 * below a 3700px-wide viewport.
 */

// Width : height of the recommended banner.
export const CATEGORY_BANNER_ASPECT = 6;

// Recommended upload size, at 2x a 1440px desktop (see DERIVATION).
export const CATEGORY_BANNER_RECOMMENDED = Object.freeze({ width: 2880, height: 480 });

// "2880 x 480 px (6:1)" -- the size as the store editor states it.
export function categoryBannerSizeLabel() {
  const { width, height } = CATEGORY_BANNER_RECOMMENDED;
  return `${width} x ${height} px (${CATEGORY_BANNER_ASPECT}:1)`;
}
